import { useCms } from "./useCms";
import { Field, Panel, ListControls, AddButton, moveItem } from "./Fields";

export default function TestimonialsEditor() {
  const { data, setData, save, saving } = useCms("testimonials", []);
  const list = Array.isArray(data) ? data : [];
  const update = (i, patch) => setData(list.map((t, idx) => (idx === i ? { ...t, ...patch } : t)));

  return (
    <Panel title={`Customer Feedback (${list.length})`} description="Only published testimonials appear on the homepage. Use real, verified customer quotes." onSave={() => save(list)} saving={saving} saveTestid="testimonials-save">
      <div className="space-y-4">
        {list.map((t, i) => (
          <div key={t.id || i} data-testid={`testimonial-row-${i}`} className={`rounded-xl border p-4 ${t.published ? "border-emerald-200 bg-emerald-50/30" : "border-slate-200"}`}>
            <div className="flex items-center justify-between mb-3">
              <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
                <input type="checkbox" data-testid={`testimonial-published-${i}`} checked={!!t.published} onChange={(e) => update(i, { published: e.target.checked })} />
                {t.published ? "Published on website" : "Draft (hidden)"}
              </label>
              <ListControls index={i} total={list.length} onMove={(a, b) => setData(moveItem(list, a, b))} onRemove={(idx) => setData(list.filter((_, j) => j !== idx))} testid={`testimonial-delete-${i}`} />
            </div>
            <div className="grid md:grid-cols-3 gap-3">
              <Field label="Customer name" value={t.name} onChange={(v) => update(i, { name: v })} testid={`testimonial-name-${i}`} />
              <Field label="Designation" value={t.designation} onChange={(v) => update(i, { designation: v })} />
              <Field label="Organization" value={t.organization} onChange={(v) => update(i, { organization: v })} />
            </div>
            <div className="mt-3">
              <Field label="Feedback / quote" multiline value={t.quote} onChange={(v) => update(i, { quote: v })} testid={`testimonial-quote-${i}`} />
            </div>
            <div className="mt-3">
              <Field label="Measurable outcome (optional)" value={t.outcome} onChange={(v) => update(i, { outcome: v })} />
            </div>
          </div>
        ))}
      </div>
      <AddButton label="Add customer feedback" testid="testimonial-add" onClick={() => setData([...list, { id: `t_${Date.now()}`, name: "", designation: "", organization: "", quote: "", outcome: "", published: false }])} />
    </Panel>
  );
}
